import { useState, type JSX } from 'react';
import { Button, Dialog, Input, Select } from '@artosera/ui';
import { useTranslation } from 'react-i18next';
import { useLieux } from '../../api/lieux.js';
import { useGesteMouvement, type MouvementPresente } from '../../api/mouvements.js';
import { estApiError } from '../../api/errors.js';
import { Field } from '../Field.js';
import styles from './MouvementDetailPage.module.css';
export function RetourDialog({
  galerieSlug,
  mouvement,
  onFermer,
}: {
  galerieSlug: string;
  mouvement: MouvementPresente;
  onFermer: () => void;
}): JSX.Element {
  const { t } = useTranslation(['regie', 'commun']);
  const lieux = useLieux(galerieSlug);
  const geste = useGesteMouvement(galerieSlug);
  const [choisies, setChoisies] = useState(
    mouvement.lignes.filter((l) => !l.retourneeLe).map((l) => l.oeuvreId),
  );
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [lieu, setLieu] = useState('avant');
  const [erreur, setErreur] = useState('');
  async function soumettre() {
    try {
      await geste.mutateAsync({
        id: mouvement.id,
        geste: 'retour',
        corps: { oeuvres: choisies, retourLe: date, ...(lieu === 'avant' ? {} : { versId: lieu }) },
      });
      onFermer();
    } catch (e) {
      setErreur(estApiError(e) ? e.message : t('commun:erreurReseau'));
    }
  }
  return (
    <Dialog
      open
      onOpenChange={(v) => {
        if (!v) onFermer();
      }}
      title={t('regie:mouvements.fiche.retour')}
      closeLabel={t('commun:actions.fermer')}
    >
      <div className={styles.form}>
        {mouvement.lignes
          .filter((l) => !l.retourneeLe)
          .map((l) => (
            <label key={l.oeuvreId} className={styles.case}>
              <input
                type="checkbox"
                checked={choisies.includes(l.oeuvreId)}
                onChange={(e) =>
                  setChoisies(
                    e.target.checked
                      ? [...choisies, l.oeuvreId]
                      : choisies.filter((id) => id !== l.oeuvreId),
                  )
                }
              />
              {l.titre}
            </label>
          ))}
        <Field htmlFor="retour-date" label={t('regie:mouvements.fiche.dateRetour')}>
          <Input
            id="retour-date"
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </Field>
        <Select
          aria-label={t('regie:mouvements.creation.versLieu')}
          value={lieu}
          onValueChange={setLieu}
          options={[
            { value: 'avant', label: t('regie:mouvements.creation.dePuis') },
            ...(lieux.data ?? []).map((l) => ({ value: l.id, label: l.nom })),
          ]}
        />
        {erreur && <p role="alert">{erreur}</p>}
        <Button
          disabled={geste.isPending || !choisies.length || !date}
          onClick={() => void soumettre()}
        >
          {t('regie:mouvements.fiche.retour')}
        </Button>
      </div>
    </Dialog>
  );
}
